import React from 'react';
import {Route, Redirect} from 'react-router-dom';
import {checkAuth} from '../utils/auth';

// A wrapper for <Route> that redirects to the signin
// screen if you're not yet authenticated.
export function PrivateRoute({children, ...rest}) {
  return (
    <Route
      {...rest}
      render={({location}) =>
        checkAuth() ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/signin',
              state: {from: location},
            }}
          />
        )
      }
    />
  );
}
